import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../assets/logo.svg";

const Banner = () => {
	const [seoOpen, setSeoOpen] = useState(false);

	return (
		<section className="banner">
			<div className="banner-content">
				<img src={logo} alt="Airport Taxi Transfers Varna" className="logo" />
				<h1 className="banner-tagline">Airport Taxi Transfers Varna</h1>
				<p className="banner-subtitle">
					Reliable private transfers across the Black Sea coast — 24/7, fixed
					prices, no hidden fees
				</p>

				<button
					type="button"
					className="banner-read-more-btn"
					onClick={() => setSeoOpen((open) => !open)}
					aria-expanded={seoOpen}
					aria-controls="banner-seo-content"
				>
					{seoOpen ? "Read less" : "Read more"}
				</button>

				<div
					id="banner-seo-content"
					className={`banner-seo-content${seoOpen ? " banner-seo-content-open" : ""}`}
					aria-hidden={!seoOpen}
				>
					<div className="banner-seo-inner">
						<h2 className="banner-seo-title">
							Private airport taxi &amp; resort transfers from Varna
						</h2>
						<p>
							<strong>Airport Taxi Transfers Varna</strong> provides licensed
							private taxi and minibus transfers from{" "}
							<strong>Varna Airport (VAR)</strong> and Varna city to hotels and
							apartments along the Bulgarian Black Sea coast. Book online in
							advance or on the day of travel — we operate{" "}
							<strong>24 hours a day, 7 days a week</strong>, including late-night
							and early-morning flights.
						</p>
						<p>
							Our service is built around <strong>fixed prices</strong> quoted
							before you travel: no meter surprises, no hidden surcharges, and
							free waiting time at the airport when your flight is delayed. Every
							transfer includes a professional, English-speaking driver, help with
							luggage, and the option to pay by card or cash. Child seats and
							meet-and-greet at arrivals are available on request.
						</p>
						<p>
							Whether you need a quick ride to Golden Sands, a family transfer
							to Albena or Sunny Beach, a coastal trip to Balchik or Kranevo, or
							a long-distance journey to Burgas Airport or Bucharest, we offer
							door-to-door comfort in clean, air-conditioned vehicles.
						</p>

						<h3 className="banner-seo-subtitle">Popular transfer routes</h3>
						<ul className="banner-seo-routes">
							<li>
								<Link to="/destinations/varna-to-golden-sands">
									Varna to Golden Sands
								</Link>
							</li>
							<li>
								<Link to="/destinations/varna-to-albena">Varna to Albena</Link>
							</li>
							<li>
								<Link to="/destinations/varna-to-kranevo">
									Varna to Kranevo
								</Link>
							</li>
							<li>
								<Link to="/destinations/varna-to-balchik">
									Varna to Balchik
								</Link>
							</li>
							<li>
								<Link to="/destinations/varna-to-sunny-beach">
									Varna to Sunny Beach
								</Link>
							</li>
							<li>
								<Link to="/destinations/varna-to-burgas">
									Varna to Burgas
								</Link>
							</li>
							<li>
								<Link to="/destinations/varna-to-bucharest">
									Varna to Bucharest
								</Link>
							</li>
						</ul>

						<p>
							Use the booking form below to reserve your transfer in minutes.
							Enter your pickup and drop-off locations, date and time, and we
							will confirm your journey by phone or email. For the best experience,
							book early during the summer season — especially for transfers to
							Sunny Beach, Burgas, and Bucharest.
						</p>
					</div>
				</div>
			</div>
		</section>
	);
};

export default Banner;
